import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";

import { useNavigate } from "react-router-dom";

const CategoryTree = ({ onSelectCategory }) => {
  const [openNodes, setOpenNodes] = useState([]);
  const [tree, setTree] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get("/categories?limit=1000").then((res) => {
      if (res.data.status) {
        const categories = res.data.categories;
        const treeData = buildTree(categories);
        setTree(treeData);
      }
    });
  }, []);

  const buildTree = (list) => {
    const map = {};
    const roots = [];

    list.forEach((item) => {
      map[item._id] = { ...item, children: [] };
    });

    list.forEach((item) => {
      if (item.parentId) {
        map[item.parentId]?.children.push(map[item._id]);
      } else {
        roots.push(map[item._id]);
      }
    });

    return roots;
  };

  const toggleNode = (id) => {
    setOpenNodes((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleClick = (item) => {
    if (item.children.length) {
      toggleNode(item._id);
    } else if (onSelectCategory) {
      onSelectCategory(item);
    }
  };

  const renderTree = (items, level = 0) => (
    <ul className="list-unstyled ps-2">
      {items.map((item) => (
        <li
          key={item._id}
          className={`mb-1 ${level === 0 ? "border-bottom pb-2" : ""}`}
        >
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ cursor: "pointer" }}
            onClick={() => handleClick(item)}
          >
            <span style={{ fontWeight: level === 0 ? "bold" : "normal" }}>
              {item.name}
            </span>
            {item.children.length > 0 && (
              <span className="text-muted small">
                {openNodes.includes(item._id) ? "▲" : "▼"}
              </span>
            )}
          </div>

          {item.children.length > 0 && openNodes.includes(item._id) && (
            <div className="ms-3 border-start ps-2 mt-1">
              {renderTree(item.children, level + 1)}
            </div>
          )}
        </li>
      ))}
    </ul>
  );

  return <div className="category-tree">{renderTree(tree)}</div>;
};


export default CategoryTree;
